import AdvertisementOverlay, { AdvertisementOverlayProps } from '@/components/advertisements/AdvertisementOverlay';
import { useLiveStreamPlayerStateContext } from '@/components/LiveStreamPlayer/contexts';

const HomeAdvertisementOverlay = (props: AdvertisementOverlayProps) => {
  const { isMuted, isPlaying } = useLiveStreamPlayerStateContext();

  if (!isPlaying) {
    return null;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AdvertisementOverlay muted={isMuted} {...props} />;
};

export default HomeAdvertisementOverlay;
